import { useEffect, useState } from 'react';
import Translator from '../../../classes/Translator/Translator';

const CardProjectsLogic = (getProjects, updateProjects, orderingRecentProjects, orderingAlphabeticallyProjects) => {
    const { translator } = Translator();
    
 /*  const [projects, setProjects] = useState({
    project: {}
  });

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getProjects().then((project) => {
      setIsLoading(false);
      return setProjects({ ...projects, project });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    updateProjects().then((project) => {
      setIsLoading(false);
      return setProjects({ ...projects, project });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSortOptionChange = async (sortOption) => {
    setIsLoading(true);
    try {
      let projectList = [];
      if (sortOption === "Most Recent") {
        projectList = await orderingRecentProjects();
      } else if (sortOption === "Alphabetically") {
        projectList = await orderingAlphabeticallyProjects();
      }
      setProjects(projectList);
    } catch (error) {
      // console.error(error);
    } finally {
      setIsLoading(false);
    }
  }; */

  return {
/*     handleSortOptionChange,
    projects,
    isLoading, */
    translator
  };
};

export default CardProjectsLogic;


